
import { Component, Vue, Watch } from "vue-property-decorator";

import FormBase from "@/lib/view-base/formbase";
import { UpdateProductDto, ProductService, ProductCategoryService, UpdateProductMoreFileDto, CreateOrUpdateProductSpecificationDto,Int64EntityDto } from "@/api/service-proxies";
import SelectTree from "@/components/SelectTree/SelectTree.vue";
import WangEditor from 'wangeditor'
import appconst from "@/lib/appconst";
import imgOrVideo from "@/components/uploader/imgAndVideo.vue"
import ImageUploader from '@/components/uploader/imageUploader.vue'
import PreViewDialog from "../components/previewDialog.vue";
import { formatJson } from "@/lib";
@Component({
    name: "UpdateProduc",
    components: {
        SelectTree, imgOrVideo, ImageUploader, PreViewDialog
    },
})
export default class CreateTenant extends FormBase {
    product: UpdateProductDto = new UpdateProductDto();
    productService: ProductService = new ProductService();
    //商品分类
    productCategoryService: ProductCategoryService = new ProductCategoryService();
    productCategoryType: any = [];
    radio: 3
    imgList = new Array();
    rules: object = {
        name: [{ required: true, message: "请输入商品名称", trigger: "blur" }],
        productCategoryId: [
            { required: true, message: "请选择商品类型", trigger: "blur" },
        ],

        price: [
            { required: true, message: "请输入商品价格", trigger: "blur" },
        ],
        // IsFree: [
        //     { required: true, message: "是否包邮", trigger: "blur" },
        // ],

        introduction: [],
        isRegisterd: [],
        organizationUnitId: [],
    };
    buttonlist: any = []
    defaultProps = {
        parent: "parentId", // 父级唯一标识
        value: "id", // 唯一标识
        label: "displayName", // 标签显示
        children: "children",
    };
    options = [];
    imageUploadAction = appconst.remoteServiceBaseUrl + 'sysadmin/UploadFile/ProductUpload'
    inputValue2: any = '' // 正文内容  textarea框值
    productImg = ''
    mounted() {


        this.initServer();
        this.getProduct(+this.$route.params["id"]);
    }
    async getProduct(id: number) {

        let product = await this.productService.get(id);
        this.product = <UpdateProductDto>product;
        this.product.p_Path = (this as any).$aes.imgAddAuth(this.product.p_Path)
        this.product.imageList.forEach(e=>{
            e.p_Path = (this as any).$aes.imgAddAuth(e.p_Path)
          })
        this.inputValue2 = this.product.describe
        var str = this.product.salesType;
        this.buttonlist.forEach(item => {
            if (str.includes(item.id)) {
                item.isSelect = true;
            }
        });
        // this.imgList.push(file.response.result.url);
        var _that = this;
        this.product.imageList.forEach(function (e) {
            var obj = new Object();
            obj["url"] = e.p_Path;
            obj["id"] = e.id;
            _that.imgList.push(obj);

        });
        this.initEditor();
        this.initProductCategory();
    }


    created() { }


    async submitExecute(): Promise<void> {
        this.product.state = 1;
        this.product.describe = this.inputValue2;
        var salesTypeID = this.buttonlist.filter(item => item.isSelect).map(item => item.id);

        this.product.salesType = JSON.stringify(salesTypeID).replace("[", "").replace("]", "");
        this.product.p_Path = (this as any).$aes.imgDelAuth(this.product.p_Path)
        this.product.imageList.forEach(e=>{
            e.p_Path = (this as any).$aes.imgDelAuth(e.p_Path)
          })
          debugger
        await this.productService.update(this.product);
    }
    handleSuccess(response, file, fileList) {
        this.product.p_Path = (this as any).$aes.imgAddAuth(response.result.url)

    }

    private initEditor() {
        let editor = new WangEditor('#editor')
        editor.config.menus = [
            'head',
            'bold',
            'fontSize',
            'italic',
            'underline',
            'strikeThrough',
            'indent',
            'lineHeight',
            'foreColor',
            'backColor',
            'list',
            'justify',
            'quote',
            'emoticon',
            'image',
            //'video',
            'splitLine',
            'undo',
            'redo',
        ]
        editor.config.zIndex = 20
        editor.config.uploadImgServer = this.imageUploadAction
        editor.config.uploadFileName = 'file'
        editor.config.uploadImgHooks = {
            customInsert: (insertImgFn: any, response: any) => {
                editor.cmd.do(
                    'insertHTML',
                    `<img src="${(this as any).$aes.imgAddAuth(response.result.url)}" style="max-width:100%;" contenteditable="false"/>`
                )
            },
        }
        editor.config.uploadVideoServer = this.imageUploadAction
        editor.config.uploadVideoName = 'file'
        editor.config.uploadVideoMaxSize = 1 * 1024 * 1024 * 100 // 100M
        editor.config.uploadVideoAccept = ['mp4']
        editor.config.uploadVideoHooks = {
            before: (xhr) => {
                if (this.inputValue2) {
                    let div = document.createElement('div')
                    div.innerHTML = this.inputValue2
                    if (div.querySelectorAll('video').length >= 3) {
                        return {
                            prevent: true,
                            msg: '最多只能上传3个视频',
                        }
                    }
                }
            },
            customInsert: (insertVideoFn: any, response: any) => {
                editor.cmd.do(
                    'insertHTML',
                    `<p><video poster="${(this as any).$aes.imgAddAuth(response.result.url)}" controls="controls" style="max-width:100%"><source src="${(this as any).$aes.imgAddAuth(response.result.url)}" type="video/mp4" /></video></p><p>&#8203</p>`
                )
            },
        }
        editor.config.onchange = (html) => {
            this.inputValue2 = html
        }
        editor.create()
        editor.txt.html(this.inputValue2)
    }

    //获取商品分类的数据
    initProductCategory() {
        var _that = this;
        this.productCategoryService.getAllProductCategory().then(res => {
            _that.productCategoryType = res;
        });




    }

    handleMoreSuccess(response: any, file: any, fileList) {

        console.info("文件类型" + JSON.stringify(file));
        // 假设上传成功后服务器返回的图片URL在response.url中
        this.product.imageList.push(new UpdateProductMoreFileDto({
            p_Path: response.result.url,
            attachmentType: file.name.substring(file.name.lastIndexOf(".") + 1),
            id: 0
        }));
        this.imgList.push(file.response.result.url);


    }
    handleRemove(file, fileList) {
        // 移除图片时更新列表
        this.product.imageList = this.product.imageList.filter(img => img.p_Path !== file.url);

        if (file.id) {
            this.productService.deleteAttachment(file.id);
        }
    }
    //增加科目
    handleAddExperienceline() {
        if (this.product.specificationList == undefined) {
            this.product.specificationList = new Array();
        }
        let obj = new CreateOrUpdateProductSpecificationDto({
            id: 0,
            /** 规格名称 */
            specName: "",
            /** 赠送积分 */
            integral: 0,
            /** 库存 */
            inventoryNum: 999,
            /** 折扣前价格 */
            beforePrice: 0,
            /** 折扣后价格 */
            afterPrice: 0,
            /** 是否选中 */
            isSelect: false,
        });

        this.product.specificationList.push(obj);
    }

    //保存单行数据
    async handlesaveExperience(index, rowData) {


    }
    handleDeleteExperience(index, rowData) {
        if (rowData.id > 0) {
            this.productCategoryService.deleteASpe(rowData.id);
        }

        this.product.specificationList = this.product.specificationList.filter((element, i) => i !== index);

    }
//默认选中
handleDefaultSelection(index, rowData) {
   this.product.specificationList.map(item => {
       item.isSelect=false;
      });
       rowData.isSelect=true;
        if (rowData.id > 0) {
            var item = new Int64EntityDto();
            item.id = rowData.id;
            this.productCategoryService.defaultSelection(item );
        }
    }

    initServer() {
        this.productService.getSalesServiceTypeList().then((result) => {

            this.buttonlist = result;
        });
    }

    statusSwitchChange(isFree) {

        this.product.isFree = isFree;

    }
    // 打开预览弹框
    openDialog(index) {
        (this.$refs.preViewDialogRef as PreViewDialog).open(this.product.imageList,
            index
        );
    }
    // 删除已选图片或视频
    delImgOrVideo(index) {
        var id = this.product.imageList[index].id;
        this.product.imageList.splice(index, 1);
        if (id > 0) {
            this.productService.deleteAttachment(id);
        }
    }
    // 图片返回数据
    handleImageORVideoSuccess(url) {
        var isImg = "video";
        if (
            url.type.slice(0, 6) == "image/" ||
            url.type.slice(0, 6) == "video/"
        ) {
            if (url.type.slice(0, 6) == "image/") {
                isImg = "png";
            }
            var obj = {
                url: url.url,
                isImg: isImg,

            }
            this.product.imageList.push(new UpdateProductMoreFileDto({
                p_Path: (this as any).$aes.imgAddAuth(url.url),
                attachmentType: isImg,
                id: 0

            }));
        }
        // this.product.imageList.push(url)
    }
}
